import React from 'react';
import StepsCompute from './components/StepsCompute';
import {ExpressBox} from "./express/ExpressBox";
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../../store/spirs/types";
import {REMOVE_COUPON_EVENT} from "../../../store/spirs/actions";
import {CouponEvent} from "../../../store/spirs/reducers/couponReducer";
import {useTranslation} from "react-i18next";
import { ScrollContainer } from '../scrollContainer';

interface SystemListProps {
    couponEvents: CouponEvent[];
}

export function SystemList(props: SystemListProps) {
    const {couponEvents} = props;
    const rate = useSelector((state: StoreType) => state.spirs.coupons.rate.SYSTEM);
    const dispatch = useDispatch();
    const {t} = useTranslation();


    function removeEventFromCoupon(selectionId: number | undefined) {
        if (!selectionId) {
            throw Error('selectionId must be number, undefined passed');
        } else {
            dispatch(REMOVE_COUPON_EVENT(selectionId));
        }
    }

    function getMessageInfo() {
        const activeEventsCount = couponEvents.filter(e => e.active).length;
        if (activeEventsCount <= 2) return '';
        return t('coupons.SYSTEM.info', {m: activeEventsCount - 1, n: activeEventsCount});
    }

    return (
        <>
            <div className="uppercase">{getMessageInfo()}</div>

            <div className="rounded-[8px] bg-[#272D33] overflow-hidden">
                { couponEvents.length ? <ScrollContainer className="overflow-y-auto max-h-[calc(100vh-557px)] notebook:max-h-[calc(100vh-634px)]">
                    {couponEvents.map((event) => (
                        <div className="bg-[#272D33] overflow-hidden" key={event.selectionId}>
                            <ExpressBox event={event}
                                        removeEventFromCoupon={() => removeEventFromCoupon(event.selectionId)}
                                        index={event.selectionId}
                            />
                        </div>
                    ))}
                </ScrollContainer> : null}
                {couponEvents.length > 0 ? <StepsCompute rate={rate}/> : ''}

            </div>
        </>
    );
}
